<div class="customer-view-container">
  <h1>Welcome {{ customerName$ | async }}</h1>
  <div class="customer-view-sections">
    <div class="section">
      <h2>Drafted Orders</h2>
      @for (draft of drafts$ | async; track draft.id) {
        <aa-order-list-card [order]="draft"></aa-order-list-card>
      }
      @if (((drafts$ | async) ?? []).length < 1) {
        <p>No drafts yet.</p>
      }
    </div>
    <div class="section">
      <h2>Submitted Orders</h2>
      @for (submission of submissions$ | async; track submission.id) {
        <aa-order-list-card [order]="submission"></aa-order-list-card>
      }
      @if (((submissions$ | async) ?? []).length < 1) {
        <p>No submissions yet.</p>
      }
    </div>

    <div class="section">
      <h2>Meetings</h2>
      @for (meeting of meetings$ | async; track meeting.id) {
        <aa-meeting-card [meeting]="meeting"></aa-meeting-card>
      }
      @if (((meetings$ | async) ?? []).length < 1) {
        <p>No meetings yet.</p>
      }
    </div>
  </div>
</div>

<button
  id="create-order-button"
  mat-fab
  color="primary"
  routerLink="draft-editor"
  matTooltip="Start Order"
  matTooltipPosition="left"
  #createTooltip="matTooltip">
  <mat-icon>add</mat-icon>
</button>
<button
  id="schedule-meeting-button"
  mat-fab
  color="primary"
  routerLink="schedule-meeting"
  matTooltip="Schedule Meeting"
  matTooltipPosition="left"
  #scheduleTooltip="matTooltip">
  <mat-icon>calendar_add_on</mat-icon>
</button>
